import { TweenMax, Power3 } from 'gsap/all';
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollToPlugin)

export default class ScrollNextSection {

  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }

  setVars() {
    
    this.settings = {
      'main': 'data-scroll-next-section'
    };

    this.scroll = document.querySelector(`[${this.settings.main}]`);
    
    if (!this.scroll) return;
    
    return true;
  }

  setEvents() {
    this.scroll.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const sectionHeight = document.querySelector(e.target.getAttribute(this.settings.main));
      TweenMax.to(window, 1, { scrollTo: {y: sectionHeight.clientHeight + 80}, ease: Power3.easeInOut })
    });
  }
}
